import Vue from 'vue';
import Router from 'vue-router';
import VueMeta from 'vue-meta';
import NProgress from '@utils/nprogress';
import { isAuthorized } from '@utils/authutils';
import routes from './routes';

Vue.use(Router);
Vue.use(VueMeta, {
  keyName: 'page'
});

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  // eslint-disable-next-line global-require
  const Auth = require('@utils/auth').default;
  const authResult = isAuthorized(Auth, to);

  const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  if (authResult.success) {
    next();
  } else {
    next({ name: authResult.next });
  }
});

// eslint-disable-next-line no-unused-vars
router.afterEach((routeTo, routeFrom) => {
  NProgress.done();
});

Vue.router = router;

export default router;
